module.exports = __webpack_public_path__ + "img/web.e864675b.svg";